// extracted by mini-css-extract-plugin
var _1 = "VersionChangesWall-module__animateUploadProgressBarWidth--bNfnv";
var _2 = "VersionChangesWall-module__animatedBackground--wAZSz";
var _3 = "36px";
var _4 = "VersionChangesWall-module__container--a_NRQ";
var _5 = "VersionChangesWall-module__item--iNKyl";
var _6 = "VersionChangesWall-module__wallItems--ieRtw";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "authorCardGap", _4 as "container", _5 as "item", _6 as "wallItems" }
